<template>
    <div class="newItem">
        <div class="content" @click="goToDetail">
            <img class="list-topping keep-hue" :src="require('@/assets/Home/Index/NewsIndex/newTop.png')" v-if="data.topStatus === '1'">
            <div class="content-text-box" :class="data.read=== '1' ? 'readed-active' : ''">
                <template v-if="mode === 'normal' || (mode === 'pic' && !data.titleImage)">
                    <div class="left-box-content-title" >
                        <!-- 如果有置顶标签，则标题字体加粗。 -->
                        <p class="title">{{data.title || '-'}}</p>
                        <p class="list-new keep-hue" v-if="data.isNewNews"></p>

                    </div>

                </template>
                <template v-if="mode === 'pic' && data.titleImage">
                    <div class="main" >
                        
                        <!-- 如果有置顶标签，则标题字体加粗。 -->
                        <div class="main-left">
                            <p class="title twoRowEllipsis">{{data.title || '-'}}</p>
                            <p class="desc threeRowEllipsis">{{data.contentDesc}}</p>
                            <p class="list-new" v-if="data.isNewNews">
                                <img class="new keep-hue" :src="require('@/assets/Home/Index/NewsIndex/newNews.png')">
                            </p>
                            
                        </div>
                        <div class="main-right">
                            <img class="keep-hue" :src="data.titleImage.split(',')[0]" alt="">
                        </div>
                    </div>

                </template>
<!--                <template v-if="mode === 'pic' && data.titleImage && data.titleImage.split(',').length > 1">-->
<!--&lt;!&ndash;                    <div class="main">&ndash;&gt;-->

<!--&lt;!&ndash;                        &lt;!&ndash; 如果有置顶标签，则标题字体加粗。 &ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="main-left">&ndash;&gt;-->
<!--&lt;!&ndash;                            <p class="title twoRowEllipsis">{{data.title || '-'}}</p>&ndash;&gt;-->
<!--&lt;!&ndash;                            <p class="desc twoRowEllipsis">{{data.contentDesc}}</p>&ndash;&gt;-->
<!--&lt;!&ndash;                            <p class="list-new" style="display: none">&ndash;&gt;-->
<!--&lt;!&ndash;                                <img class="new" :src="require('@/assets/Home/Index/NewsIndex/newNews.png')">&ndash;&gt;-->
<!--&lt;!&ndash;                            </p>&ndash;&gt;-->

<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="main-right">&ndash;&gt;-->
<!--&lt;!&ndash;                            <img :src="data.titleImage" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--                    -->

<!--                </template>-->

                <div class="publish">
                    <span class="publish-unit">发布单位：{{data.releaseDeptName || '-'}}</span>

                    <span class="publish-time oneRowEllipsis">发布时间：{{formatTimestamp(data.releaseStartTime, 'yyyy-MM-dd HH:mm') || '-'}} </span>
                </div>
            </div>
        </div>

    </div>
    
</template>

<script>
    import {formatTimestamp} from '@/utils/utils';
    import { writeReadRecord } from "@/api/news";
    import {mapGetters} from "vuex";
    export default {
        name: "NewItem",
        props: {
            data: { type: Object, default: ()=> {}},
            mode: { type: String, default: 'normal'},
        },
      computed: {
        ...mapGetters(["serveUrl", "request"]),
      },
        methods:{
            formatTimestamp(data,formmat) {
                return formatTimestamp(data, formmat);
            },
          // 记录资讯访问
          writeReadRecord() {
            let data = {contentId:this.data.id, request: this.request,
              serveUrl: this.serveUrl,
              header: "portal"}
            writeReadRecord(data);
          },
            goToDetail(){
                // 点击设置已读状态
                if(this.data.read !== '1') this.$set(this.data,'read','1');
                this.writeReadRecord();
                if(this.data.url) {
                    window.open(this.data.url)
                    return false;
                }
                let a = this.$router.resolve({ name: "NewsDetail", query: { id: this.data.id,columnId:this.data.columnId } })
                window.open(a.href)
            }

        }
    }
</script>

<style scoped lang="scss">
  @import "@/styles/variables.scss";
    .newItem {
        .content {
            width: 100%;
            display: flex;
            border-bottom: 1px dashed rgba(219,219,219,.8);
            padding: 7px 0 6px;
            overflow: hidden;
            position: relative;
            .list-topping {
                width: 20px;
                height: 42px;
                top: 10px;
                left: 0;
                position: absolute;
                z-index: 0;
            }
            .content-text-box {
                width: calc(100% - 33px);
                float: left;
                margin-left: 33px;
                cursor: pointer;
                &.readed-active {
                    .title{
                        color: #666666;
                      &:hover {
                        color: $color-primary;
                      }
                    }
                    .main {
                        .main-left {
                            .title{
                              color: #999999;
                              &:hover {
                                color: $color-primary;
                              }
                            }
                        }
                    }
                }
                .main {
                    display: flex;
                    margin-bottom: 16px;
                    &-left {
                        margin-right: 40px;
                        flex:1;

                        .title{
                            color: #000;
                            font-size: 15px;
                            height:50px;
                        }
                        .desc {
                            margin-top: 12px;
                            font-size: 14px;
                            color: #333333;
                            height: 75px;
                        }
                        .list-new {
                            position: absolute;
                            right: 180px;
                            top:10px;
                            width: 31px;
                            height: 18px;
                            img {
                                width: 100%;
                            }
                        }


                    }
                    &-right {
                        width: 170px;
                        height: 120px;
                        img{
                            width: 100%;
                            height:100%;
                          object-fit: cover;

                        }
                    }
                }
                .left-box-content-title {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 14px;
                    color: #000;
                  &:hover {
                    color: $color-primary;
                  }
                    a:visited {
                        color: #aaa;
                    }
                    .title {
                        flex:1;
                        width: auto;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        font-size: 15px;
                        margin-bottom: 0;
                    }
                    .list-new {
                        width: 31px;
                        padding-left: 6px;
                        height: 18px;
                        background: url("../../../../assets/Home/Index/NewsIndex/newNews.png") no-repeat;
                        background-size: 100% auto;
                    }

                }
                .publish {
                    display: flex;
                    justify-content: space-between;
                    span {
                        font-size: 12px;
                        color: #959595;
                    }

                    .publish-unit {
                        width: 130px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
            }
        }

    }

</style>